import React, { FC, useState, useEffect } from "react";
import { useNavigate } from "react-router";

import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { INTEGOLF_MERCHANT_ALLOWED_PAYOUT_INTERVALS, PAYOUT_INTERVAL_TO_LABEL_MAPPING } from "../../../../utils/constants";
import UpdateInfoModal from "../update-info-modal/update-info-modal";
import UpdatePhoneModal from "../change-phone-modal/update-phone-modal";
import DeleteModal from "../../../../shared/delete-modal/delete-modal";
import { authActions, currentUser, getDeleteUserProfileStatus, userDetail } from "../../../../reducers/authSlice";
import UpdatePasswordModal from "../update-password/UpdatePasswordModal";
import { useTranslation } from "react-i18next";

interface UserProfileDetailsProps {}

const UserProfileDetails: FC<UserProfileDetailsProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const userProfile: any = useAppSelector(currentUser);

    const userProfileDeleteStatus = useAppSelector(getDeleteUserProfileStatus);

    const [showUpdateInfoPopup, setShowUpdateInfoPopup] = useState(false);
    const [showUpdatePhonePopup, setShowUpdatePhonePopup] = useState(false);
    const [showUpdatePasswordPopup, setShowUpdatePasswordPopup] = useState(false);
    const [showDeleteUserPopup, setShowDeleteUserPopup] = useState(false);
    const [ userFirstName = "", setUserFirstName ] = useState<string|null>("");
    const [ userLastName = "", setUserLastName ] = useState<string|null>("");
    const [ userSecondaryEmail = "", setUserSecondaryEmail ] = useState<string|null>("");
    const [ updateEmailPayloadKey, setUpdatedEmailPayloadKey ] = useState("");

    const fetchUserDetail:any = useAppSelector(userDetail);
    const [updatedTValue,setUpdatedTValue]=useState<any>("")

    useEffect(()=>{
      dispatch(authActions.userDetail());
    },[])

    const onProfileFirstNameBlur = () => {
        if ( userFirstName != userProfile.firstname) {
            const userDataUpdatePayload = { firstname: userFirstName };
            updateUserProfileData(userDataUpdatePayload);
        }
    };
    
    const onProfileLastNameBlur = () => {
        if (userLastName != userProfile.lastname) {
            const userDataUpdatePayload = { lastname: userLastName };
            updateUserProfileData(userDataUpdatePayload);
        }
    }
    
    const showPhoneUpdateModal = (_: any) => {
        dispatch(authActions.resetUserUpdateStatus());
        dispatch(authActions.resetUserVerifyOtpStatus());
        setShowUpdatePhonePopup(true);
    }
    
    const onAddUpdateEmail = (updatePayloadKey:string) => {
        setUpdatedEmailPayloadKey(updatePayloadKey);
        dispatch(authActions.resetUserUpdateStatus());
        dispatch(authActions.resetUserVerifyOtpStatus());
        setShowUpdateInfoPopup(true);
    }
    
    const onUserDelete = () => {
        setShowDeleteUserPopup(false);
        dispatch(authActions.userProfileDelete());
    }

    const closePersonalInfoPopup = (value: any) => { 
        setShowUpdateInfoPopup(value);
        setUpdatedEmailPayloadKey("");
    };

    const updateUserProfileData = (updatePayload: any) => {
        updatePayload["_id"] = userProfile._id;
        dispatch(authActions.updateProfileData(updatePayload));
        dispatch(authActions.resetUserUpdateStatus());
    }

    useEffect(() => {
        const { firstname, lastname, secondaryEmail } = userProfile;
        setUserFirstName(firstname);
        setUserLastName(lastname);
        setUserSecondaryEmail(secondaryEmail);
    },[userProfile]);

    useEffect(() => {
        if (userProfileDeleteStatus == "success") {
            dispatch(authActions.logoutSuccess());
            navigate("/");
        }
    }, [userProfileDeleteStatus])

    const {t}=useTranslation("")

    useEffect(()=>{
        setUpdatedTValue(t)
    },[t])

    return <>
        <div className="row">
            <div className="profileWrapper__section">
                <h3 className="profileWrapper__title mb-4">
                    {t("ProfileDetailPage.title")}
                </h3>
                <div className="row gutters-10 pb-4">
                    <div className="col-12 col-sm mb-4">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                id="firstName"
                                placeholder={t("ProfileDetailPage.formFields.formField1.placeholder")}
                                value={(userFirstName||"")}
                                onChange={(e) => setUserFirstName(e.target.value)}
                                onBlur={onProfileFirstNameBlur}
                            />
                            <label htmlFor="firstName">{t("ProfileDetailPage.formFields.formField1.label")}</label>
                        </div>
                    </div>
                    <div className="col-12 col-sm mb-4">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                id="lastName"
                                placeholder={t("ProfileDetailPage.formFields.formField2.placeholder")}
                                value={(userLastName||"")}
                                onChange={(e) => setUserLastName(e.target.value)}
                                onBlur={onProfileLastNameBlur}
                            />
                            <label htmlFor="lastName">{t("ProfileDetailPage.formFields.formField1.label")}</label>
                        </div>
                    </div>
                </div>
                {
                    (userProfile?.email || userProfile?.changeEmail) ? <div className="formField mb-0">
                        <label className="_label">{t("ProfileDetailPage.formFields.formField3.label")}</label>
                        <div className="row gutters-10">
                            <div className="col">
                                <h6>{ userProfile?.changeEmail ? userProfile.changeEmail : userProfile?.email}</h6>
                            </div>
                            <div className="col-auto">
                            {
                                userProfile?.changeEmail ? <span className="verified text-danger">
                                    {t("ProfileDetailPage.formFields.formField3.Unverified")}
                                </span> : <span className="verified fw700">
                                <img
                                    src="../assets/images/icons/verify.svg"
                                    height={18}
                                    width={18}
                                    alt=""
                                />{" "}
                                    {t("ProfileDetailPage.formFields.formField3.Verified")}
                                </span>
                            }
                            </div>
                            <div className="col-auto">
                                <a
                                    href={void 0}
                                    className="color-active fw700 text-decoration-underline"
                                    onClick={() => onAddUpdateEmail('changeEmail')}
                                >
                                    {t("ProfileDetailPage.formFields.Update")}
                                </a>
                            </div>
                        </div>
                    </div> : <div className="profileWrapper__section">
                        <div className="row align-items-center">
                            <div className="col-12 col-md">
                                <h3 className="profileWrapper__title mb-3">
                                    {t("ProfileDetailPage.formFields.Email")}
                                </h3>
                                <p className="color-600 fw500 mb-0">
                                    {t("ProfileDetailPage.formFields.description")}
                                </p>
                            </div>
                            <div className="col-12 col-md-auto">
                                <button
                                    type="button"
                                    className="button button-secondary button-rounded button-border button-min-160 fw700 fontsize-12 my-2"
                                    onClick={() => onAddUpdateEmail('changeEmail')}
                                >
                                    {t("ProfileDetailPage.formFields.AddEmail")}
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
            {
                fetchUserDetail?.password && <div className="profileWrapper__section">
                    <div className="row align-items-center">
                        <div className="col-12 col-md">
                            <h3 className="profileWrapper__title mb-3">
                                {t("ProfileDetailPage.formFields.Password")}
                            </h3>
                              <p className="color-600 fw500 mb-0">*****</p>
                            
                        </div>
                        <div className="col-12 col-md-auto">
                            <button
                                type="button"
                                className="button button-secondary button-rounded button-border button-min-160 fw700 fontsize-12 my-2"
                                onClick={()=>setShowUpdatePasswordPopup(true)}
                            >
                                {t("ProfileDetailPage.formFields.UpdatePassword")}
                            </button>
                        </div>
                    </div>
                </div>
            }
            {
                <div className="profileWrapper__section">
                    <div className="row align-items-center">
                        <div className="col-12 col-md">
                            <h3 className="profileWrapper__title mb-3">
                                {t("ProfileDetailPage.formFields.Phone")}
                            </h3>
                            {   userProfile?.phone?.number ? <p className="color-600 fw500 mb-0">
                                    +{userProfile?.phone?.countryCode}-{userProfile?.phone?.number}
                                </p> : <p className="color-600 fw500 mb-0">
                                    {t("ProfileDetailPage.formFields.descriptionforPhone")}
                                </p>
                            }
                        </div>
                        <div className="col-12 col-md-auto">
                            <button
                                type="button"
                                className="button button-secondary button-rounded button-border button-min-160 fw700 fontsize-12 my-2"
                                onClick={showPhoneUpdateModal}
                            >
                                {userProfile?.phone?.number ? t("ProfileDetailPage.formFields.UpdatePhone") : t("ProfileDetailPage.formFields.AddPhone")}
                            </button>
                        </div>
                    </div>
                </div>
            }
            {/* <div className="profileWrapper__section">
                <h3 className="profileWrapper__title mb-3">
                    Login Services
                </h3>
                <p className="color-600 fw500">
                    Connect an external login services to quickly and
                    securely login.
                </p>
                <div className="row">
                    <div className="col-auto">
                        <button
                            type="button"
                            className="button button-block button-border button-rounded mt-3 button-social"
                            onClick={() => googleLogin()}
                            disabled={!!userProfile.googleId}
                        >
                            <span className="icon">
                            <img
                                src="../assets/images/icons/google.svg"
                                alt="facebook"
                                height={18}
                            />
                            </span>{" "}
                            Continue with Google
                        </button>
                    </div>
                </div>
            </div> 
            <div className="profileWrapper__section">
                <div className="row align-items-center">
                    <div className="col-12 col-md">
                        <h3 className="profileWrapper__title mb-3">
                            Login Services
                        </h3>
                        <p className="color-600 fw500 mb-0">
                            Last password changed 45 days ago.
                        </p>
                    </div>
                    <div className="col-12 col-md-auto">
                        <button
                            type="button"
                            className="button button-secondary button-rounded button-border button-min-160 fw700 fontsize-12 my-2"
                            onClick={() => setShowUpdatePhonePopup(true)}
                        >
                            Change Password
                        </button>
                    </div>
                </div>
            </div>*/}
            {   
                userProfile?.email && <div className="profileWrapper__section">
                    <div className="row align-items-center">
                        <div className="col-12 col-md">
                            <h3 className="profileWrapper__title mb-3">
                                {t("ProfileDetailPage.formFields.SecondaryEmail")}
                            </h3>
                            {
                                userProfile?.secondaryEmail ? <p className="color-600 fw500 mb-0">
                                    {userProfile?.secondaryEmail}
                                </p> : <p className="color-600 fw500 mb-0">
                                    {t("ProfileDetailPage.formFields.SecondaryEmaildescription")}
                                </p>
                            }
                        </div>
                        <div className="col-12 col-md-auto">
                            <button
                                type="button"
                                className="button button-secondary button-rounded button-border button-min-160 fw700 fontsize-12 my-2"
                                onClick={() => onAddUpdateEmail('secondaryEmail')}
                            >
                                { userProfile?.secondaryEmail ? t("ProfileDetailPage.formFields.UpdateEmail") : t("ProfileDetailPage.formFields.AddEmailBtn")}
                            </button>
                        </div>
                    </div>
                </div>
            }
            <div className="profileWrapper__section">
                <div className="row align-items-center">
                    <div className="col-12 col-md">
                    <h3 className="profileWrapper__title mb-3">
                        {t("ProfileDetailPage.formFields.RemoveAccount")}
                    </h3>
                    <p className="color-600 fw500 mb-0">
                      {t("ProfileDetailPage.formFields.RemoveAccountDescription")}
                    </p>
                    </div>
                    <div className="col-12 col-md-auto">
                    <button
                        type="button"
                        className="button bg-danger text-white button-rounded button-border button-min-160 fw700 fontsize-12 my-2"
                        onClick={() => setShowDeleteUserPopup(true)}
                    >
                        {t("ProfileDetailPage.formFields.Delete")}
                    </button>
                    </div>
                </div>
            </div>
        </div>
        <UpdatePasswordModal
            hasModalVisible={showUpdatePasswordPopup}
            handleClose={()=>setShowUpdatePasswordPopup(false)}
            emailPayloadKey={updateEmailPayloadKey}
        />
        <UpdateInfoModal
            hasModalVisible={showUpdateInfoPopup}
            handleClose={closePersonalInfoPopup}
            emailPayloadKey={updateEmailPayloadKey}
        />
        <UpdatePhoneModal 
            isModalVisible={showUpdatePhonePopup} 
            handleClose= {()=>setShowUpdatePhonePopup(false)}
            userProfile = {userProfile}
        />
        <DeleteModal
          message={t("DeleteModal.message")}
          buttonText={t("DeleteModal.buttonText")}
            showModal={showDeleteUserPopup}
            onCloseClick={() => setShowDeleteUserPopup(false)}
            onDeleteClick={onUserDelete}
        />
    </>;
}

export default UserProfileDetails;